import { useParams } from 'react-router-dom';

import { Card } from '@/components/ui/card';
import { ProjectShell } from '@/project-management/components/layout/project-shell';
import { WorkstreamsQuery } from '@/project-management/queries/workstreams.query';

import {
  CompletedTasksLegend,
  OpenTasksLegend,
} from './components/task-priority-legend';
import { Timeline } from './components/timeline';
import { TimelineEmpty } from './timeline.empty';
import { TimelineLoading } from './timeline.loading';

export function TimelinePage() {
  const { siteId } = useParams<{ siteId: string }>();
  const workstreamsQuery = WorkstreamsQuery.useQuery({ siteId });

  if (workstreamsQuery.isLoading) {
    return <TimelineLoading />;
  }

  if (workstreamsQuery.isError || !workstreamsQuery.data) {
    throw workstreamsQuery.error;
  }

  const { workstreams } = workstreamsQuery.data;

  return (
    <ProjectShell testId="project-management-timeline" className="space-y-4">
      <Card className="space-y-4 p-6">
        {workstreams.length === 0 ? (
          <TimelineEmpty />
        ) : (
          <>
            <Timeline workstreams={workstreams} />

            <div className="flex gap-8 border-t border-gray-200 pt-4 text-sm text-neutral-600 [&>*]:min-w-40">
              <CompletedTasksLegend />
              <OpenTasksLegend />
            </div>
          </>
        )}
      </Card>
    </ProjectShell>
  );
}

export default TimelinePage;
